import { render, staticRenderFns } from "./ligatureQuestion.vue?vue&type=template&id=7d5ec576&scoped=true&lang=pug"
import script from "./ligatureQuestion.vue?vue&type=script&lang=js"
export * from "./ligatureQuestion.vue?vue&type=script&lang=js"
import style0 from "./ligatureQuestion.vue?vue&type=style&index=0&id=7d5ec576&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5ec576",
  null
  
)

export default component.exports